import { FC, memo, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useAuth } from '@features/auth';
import Logo from '@assets/img/logo.svg';

import { LayoutHeaderProps } from '../types';
import { User } from './user';

import styles from './styles.module.scss';

const HeaderComponent: FC<LayoutHeaderProps> = () => {
	/* кешируем base64‑строку, чтобы не пересчитывать на каждый рендер */
	const logoSrc = useMemo(() => `data:image/svg+xml;base64,${btoa(Logo)}`, []);
	const { isAuthorized } = useAuth();

	return (
		<header className={styles.Header}>
			<Link className={`${styles.Logo} ${styles.smHidden}`} to="/">
				<img alt="Logo" src={logoSrc} />
			</Link>

			{isAuthorized && (
				<div className={styles.Options}>
					<div className={`${styles.OptionsItem} ${styles.user}`}>
						<User />
					</div>
				</div>
			)}
		</header>
	);
};

export const Header = memo(HeaderComponent);
